var exports = {};

class CustomException extends Error {
  constructor(t) {
    super(t || this.defaultMessage);
  }

}

class NotImplementedException extends CustomException {
  constructor(t) {
    this.defaultMessage = "This functionality is not implemented yet.", super(t);
  }

}

class InvalidInitialization extends CustomException {
  constructor(t) {
    this.defaultMessage = "This initialization process is invalid.", super(t);
  }

}

class BadRequest extends CustomException {
  constructor(t) {
    this.defaultMessage = "This request has bad parameters.", super(t);
  }

}

exports.default = CustomException, exports = {
  CustomException,
  NotImplementedException,
  InvalidInitialization,
  BadRequest
};
export default exports;